import {
  BlockType,
  ColorSchemeSchema,
  FieldGroupSchema,
  FieldRole,
  ResourceListFieldSchema,
  ResourceSchema,
  RichTextFieldSchema,
} from './Types';
import { z } from 'zod';

const MagicResourceLibraryStyleOptionsSchema = z.object({
  backgroundColor: z.string().optional(),
});

const MagicResourceLibraryOptionsSchema = z.object({
  colorScheme: ColorSchemeSchema.optional(),
  preheaderEnabled: z.boolean().optional(),
  subheaderEnabled: z.boolean().optional(),
  style: MagicResourceLibraryStyleOptionsSchema.optional(),
  layout: z.string().optional(),
});

const MagicResourceLibraryTopLevelPreheaderFieldSchema = RichTextFieldSchema.extend({
  name: z.literal('preheader'),
  role: z.literal(FieldRole.Preheader),
});

const MagicResourceLibraryTopLevelHeaderFieldSchema = RichTextFieldSchema.extend({
  name: z.literal('header'),
  role: z.literal(FieldRole.Header),
});

const MagicResourceLibraryTopLevelSubheaderFieldSchema = RichTextFieldSchema.extend({
  name: z.literal('subheader'),
  role: z.literal(FieldRole.Subheader),
});

const MagicResourceLibraryTopLevelFieldSchema = z.discriminatedUnion('name', [
  MagicResourceLibraryTopLevelPreheaderFieldSchema,
  MagicResourceLibraryTopLevelHeaderFieldSchema,
  MagicResourceLibraryTopLevelSubheaderFieldSchema,
]);

const MagicResourceLibraryTopLevelFieldGroupSchema = FieldGroupSchema.extend({
  fields: z.array(MagicResourceLibraryTopLevelFieldSchema),
});

const MagicResourceLibraryResourceFieldsGroupSchema = FieldGroupSchema.extend({
  fields: z.array(
    ResourceListFieldSchema.extend({
      name: z.literal('resourceList'),
      role: z.literal(FieldRole.ResourceList),
    }),
  ),
});

export const MagicResourceBlockConfigSchema = z.object({
  options: MagicResourceLibraryOptionsSchema,
  type: z.literal(BlockType.MagicResourceLibrary),
  fieldGroups: z
    .tuple([MagicResourceLibraryTopLevelFieldGroupSchema])
    .rest(MagicResourceLibraryResourceFieldsGroupSchema),
  version: z.literal(2),
});

export type Resource = z.infer<typeof ResourceSchema>;
